var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKineCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M61.313,128h-3.313c-12.062,0-21.874-9.72-21.874-21.666V83.391h4v22.943 c0,9.741,8.018,17.666,17.874,17.666h3.313c9.856,0,17.874-7.925,17.874-17.666V44.06h4v62.274 C83.187,118.28,73.374,128,61.313,128z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M108.167,78.775h-4V42.296c0-5.152-4.247-9.344-9.468-9.344h-1.91c-5.221,0-9.468,4.191-9.468,9.344 v35.929h-4V42.296c0-7.358,6.042-13.344,13.468-13.344h1.91c7.426,0,13.468,5.986,13.468,13.344V78.775z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M106.44,105.876c-8.181,0-14.836-6.595-14.836-14.701c0-8.105,6.655-14.7,14.836-14.7 c8.18,0,14.834,6.595,14.834,14.7C121.274,99.281,114.62,105.876,106.44,105.876z M106.44,80.475c-5.975,0-10.836,4.8-10.836,10.7 s4.861,10.701,10.836,10.701c5.974,0,10.834-4.801,10.834-10.701S112.414,80.475,106.44,80.475z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M106.44,97.727c-3.64,0-6.602-2.939-6.602-6.552s2.962-6.552,6.602-6.552s6.601,2.939,6.601,6.552 S110.08,97.727,106.44,97.727z M106.44,88.623c-1.435,0-2.602,1.145-2.602,2.552s1.167,2.552,2.602,2.552 c1.434,0,2.601-1.145,2.601-2.552S107.874,88.623,106.44,88.623z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.726,41.361h-4V14.714C6.726,6.601,13.387,0,21.574,0v4c-5.981,0-10.849,4.806-10.849,10.714V41.361z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M70.528,41.566h-4V14.918c0-5.908-4.867-10.714-10.85-10.714v-4c8.188,0,14.85,6.601,14.85,14.714 V41.566z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M45.165,86.486H31.913c-13.889,0-25.188-11.189-25.188-24.942V41.33h4v20.214 c0,11.548,9.505,20.942,21.188,20.942h13.252c11.683,0,21.188-9.395,21.188-20.942V41.33h4v20.214 C70.353,75.297,59.054,86.486,45.165,86.486z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKineCenter);
export default __webpack_public_path__ + "static/media/kine-center.60d1ffee7b0db93bc8b4b18c5b1258d7.svg";
export { ForwardRef as ReactComponent };